._ConfirmationModal_1x951_1 {
  font-weight: 600;
}